import { render, staticRenderFns } from "./CurrencyDateInput.vue?vue&type=template&id=6684f2f9&scoped=true&"
import script from "./CurrencyDateInput.vue?vue&type=script&lang=js&"
export * from "./CurrencyDateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6684f2f9",
  null
  
)

export default component.exports